export default function removeDoubleCommas(string: string) {
  if (!string) return undefined
  return string.replace(/, , /g, ', ')
}